import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import PropTypes from "prop-types";
// @mui material components
import { Autocomplete, Dialog, DialogContent, Grid, MenuItem, Paper, TextField, Typography, Box, Checkbox, FormControl, FormGroup, FormLabel, FormControlLabel } from "@mui/material";
import 'chart.js/auto';

import ArcDoughnutAverage from "./dynamic/ArcDoughnutAverage";
import ArcDoughnutProportion from "./dynamic/ArcDoughnutProportion";
import ArcHistogramStep from "./dynamic/ArcHistogramStep";
import ArcListDistibution from "./dynamic/ArcListDistibution";
import ArcBarHorizontalSingle from "./dynamic/ArcBarHorizontalSingle";
import ArcBanner from "./dynamic/ArcBanner";
import ArcLineSingle from "./dynamic/ArcLineSingle";
import ArcListMultiPositive from "./dynamic/ArcListMultiPositive";
import ArcPieProportion from "./dynamic/ArcPieProportion";
import ArcListDistibution2 from "./dynamic/ArcListDistribution2";
import ArcScatter2D from "./dynamic/ArcScatter2D";
import ArcBarHorizontalProportion from "./dynamic/ArcBarHorizontalProportion";
import ArcBarVerticalProportion from "./dynamic/ArcBarVerticalProportion";
import ArcBannerWithScore from "./dynamic/ArcBannerWithScore";
import ArcLegendRYGG from "./dynamic/ArcLegendRYGG";



const DynamicComponentItem = (props) => {
    const {ReportComponentJSON, DataReportData} = props

    const DynamicComponentTranslation = {
       
       "ARC DOUGHNUT AVERAGE":ArcDoughnutAverage,
       "ARC DOUGHNUT PROPORTION":ArcDoughnutProportion,
       "ARC HISTOGRAM STEP":ArcHistogramStep,
       "ARC LIST DISTRIBUTION":ArcListDistibution,
       "ARC BAR HORIZONTAL SINGLE":ArcBarHorizontalSingle,
       "ARC BANNER": ArcBanner,
       "ARC BANNER WITH SCORE":ArcBannerWithScore ,
       "ARC LINE SINGLE": ArcLineSingle,
       "ARC LIST MULTI POSITIVE": ArcListMultiPositive,
       "ARC PIE DISTRIBUTION": ArcPieProportion,
       "ARC LIST DISTRIBUTION 2": ArcListDistibution2,
       "ARC SCATTER 2D": ArcScatter2D,
       "ARC BAR HORIZONTAL PROPORTION": ArcBarHorizontalProportion,
       "ARC BAR VERTICAL PROPORTION": ArcBarVerticalProportion,
       "ARC LEGEND RYGG": ArcLegendRYGG,
    }


    if (typeof DynamicComponentTranslation[props.ReportComponentJSON.Component] !== "undefined") {
    
        return React.createElement(DynamicComponentTranslation[props.ReportComponentJSON.Component]
            , {
                key: props.index,
                ComponentProperties: props.ReportComponentJSON.ComponentProperties,
                DataReportData: props.DataReportData,
                otherprops:props,
                elevationdisabled: props.elevationdisabled ? true : false,
                PrintView: props.PrintView,
            }
        )
    }

    return React.createElement(
        () => <div> The component {props.ReportComponentJSON.Component} doesnt exist yet</div>,
        { key: props.index }
    )
}

export default DynamicComponentItem